module.exports = __webpack_public_path__ + "img/shape02.0a61d103.svg";